import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { PaymentSipNetBankingComponent } from './payment-sip-net-banking.component';
import { InputModule } from '../input/input.module';
import { MatSelectModule } from '@angular/material/select';
import { TutorialComponent } from 'src/app/core/tutorial/tutorial.component';

@NgModule({
  declarations: [PaymentSipNetBankingComponent],
  exports: [PaymentSipNetBankingComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    MatSelectModule,
    TutorialComponent
  ]
})
export class PaymentSipNetBankingModule { }
